import { useEffect, useState } from 'react';

export const useStoreScopedAssignedEmployeeFilter = (storeId: string) => {
  const [assignedEmployeeFilter, setAssignedEmployeeFilter] = useState<string | null>(null);

  useEffect(() => {
    setAssignedEmployeeFilter(null);
  }, [storeId]);

  return {
    assignedEmployeeFilter,
    setAssignedEmployeeFilter
  };
};
